const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.TEAMS)

export const apiClientTeams = {
	fetchClientTeams: async (client_uuid: string): Promise<IClientTeamModel[]> => {
		const { data } = await apiCommon<IClientTeam[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(null, { client_uuid }),
		})

		return data.map(d => ClientTeam(d))
	},

	fetchSingleClientTeam: async (id: number): Promise<IClientTeamModel> => {
		const { data } = await apiCommon<IClientTeam>(`${groupPrefix}/${id}`, { method: 'GET' })

		return ClientTeam(data)
	},
}
